import { Typography, withStyles } from "@material-ui/core";
import MuiTableCell from "@material-ui/core/TableCell";
import MuiTableRow from "@material-ui/core/TableRow";
import { Select } from "@ofqual/portal-components/components/Select";
import React from "react";
import { ApprovalStatusSelectOptions } from "../../../../domain/ApprovalStatusSelectOptions";
import { ApprovalStatus } from "../../../../domain/ApprovalSubject";
import { AssessmentActivities } from "../../../../domain/SubjectModel";
import {
  IEvaluationApprovalCardProps,
  handleSetApprovalSubject,
} from "../utils";

const TABLE_CELL_WIDTH: string = "50%";

const TableCell = withStyles({
  root: {
    borderBottom: "none",
    padding: "2px",
  },
})(MuiTableCell);

const TableRow = withStyles({
  root: {
    padding: 0,
  },
})(MuiTableRow);

export const AssessmentApprovalCard: React.FC<IEvaluationApprovalCardProps> = ({
  subject,
  matchingLevel,
  approvalSubjects,
  setApprovalSubjects,
  dataTest,
  readOnly
}) => {
  const approvalSubject = approvalSubjects.find(
    (s) => s.subjectId === subject.id
  );

  return (
    <>
      {!!(
        subject.selectedAssessmentActivities &
        AssessmentActivities.MarkingAssessments
      ) && (
          <>
            <TableRow>
              <TableCell component="th" scope="row" width={TABLE_CELL_WIDTH}>
                <Typography variant="subtitle1">
                  Making assessment judgements
                </Typography>
              </TableCell>
              <TableCell component="th" scope="row" width={TABLE_CELL_WIDTH}>
                <Select
                  size="small"
                  value={
                    approvalSubject?.levels.find(
                      (l) => l.levelId === matchingLevel.id
                    )?.evaluationResults!.makingAssessment?.approvalStatus
                  }
                  datatest={`making-assessment-${dataTest}`}
                  onChange={(e) =>
                    handleSetApprovalSubject(
                      subject.id,
                      matchingLevel.id,
                      "makingAssessment",
                      e.target.value as unknown as ApprovalStatus,
                      approvalSubjects,
                      setApprovalSubjects
                    )
                  }
                  data-test={`select-making-assessment-${dataTest}`}
                  readOnly={readOnly}
                  label={""}
                >
                  {ApprovalStatusSelectOptions()}
                </Select>
              </TableCell>
            </TableRow>
          </>
        )}
      {!!(
        subject.selectedAssessmentActivities &
        AssessmentActivities.StandardSettingAndAwardingQualifications
      ) && (
          <>
            <TableRow>
              <TableCell component="th" scope="row" width={TABLE_CELL_WIDTH}>
                <Typography variant="subtitle1">
                  Standard setting and awarding qualifications
                </Typography>
              </TableCell>
              <TableCell component="th" scope="row" width={TABLE_CELL_WIDTH}>
                <Select
                  value={
                    approvalSubject?.levels.find(
                      (l) => l.levelId === matchingLevel.id
                    )?.evaluationResults!.standardSetting?.approvalStatus
                  }
                  datatest={`standard-setting-${dataTest}`}
                  size="small"
                  onChange={(e) =>
                    handleSetApprovalSubject(
                      subject.id,
                      matchingLevel.id,
                      "standardSetting",
                      e.target.value as unknown as ApprovalStatus,
                      approvalSubjects,
                      setApprovalSubjects
                    )
                  }
                  data-test={`select-standard-setting-${dataTest}`}
                  readOnly={readOnly}
                  label={""}
                >
                  {ApprovalStatusSelectOptions()}
                </Select>
              </TableCell>
            </TableRow>
          </>
        )}
      {!!(
        subject.selectedAssessmentActivities &
        AssessmentActivities.DesigningAndDevelopingAssessments
      ) && (
          <>
            <TableRow>
              <TableCell component="th" scope="row" width={TABLE_CELL_WIDTH}>
                <Typography variant="subtitle1">
                  Designing and developing assessments
                </Typography>
              </TableCell>
              <TableCell component="th" scope="row" width={TABLE_CELL_WIDTH}>
                <Select
                  size="small"
                  value={
                    approvalSubject?.levels.find(
                      (l) => l.levelId === matchingLevel.id
                    )?.evaluationResults!.designingDevelopingAssessments
                      ?.approvalStatus
                  }
                  datatest={`design-assessment-${dataTest}`}
                  onChange={(e) =>
                    handleSetApprovalSubject(
                      subject.id,
                      matchingLevel.id,
                      "designingDevelopingAssessments",
                      e.target.value as unknown as ApprovalStatus,
                      approvalSubjects,
                      setApprovalSubjects
                    )
                  }
                  data-test={`designing-developing-assessments-${dataTest}`}
                  readOnly={readOnly}
                  label={""}
                >
                  {ApprovalStatusSelectOptions()}
                </Select>
              </TableCell>
            </TableRow>
          </>
        )}
      {!!(
        subject.selectedAssessmentActivities &
        AssessmentActivities.EvaluatingAssessments
      ) && (
          <>
            <TableRow>
              <TableCell component="th" scope="row" width={TABLE_CELL_WIDTH}>
                <Typography variant="subtitle1">
                  Evaluating assessments or assessment approaches
                </Typography>
              </TableCell>
              <TableCell component="th" scope="row" width={TABLE_CELL_WIDTH}>
                <Select
                  size="small"
                  value={
                    approvalSubject?.levels.find(
                      (l) => l.levelId === matchingLevel.id
                    )?.evaluationResults!.evaluatingAssessments?.approvalStatus
                  }
                  datatest={`evaluating-assessment-${dataTest}`}
                  onChange={(e) =>
                    handleSetApprovalSubject(
                      subject.id,
                      matchingLevel.id,
                      "evaluatingAssessments",
                      e.target.value as unknown as ApprovalStatus,
                      approvalSubjects,
                      setApprovalSubjects
                    )
                  }
                  data-test={`evaluating-assessments-${dataTest}`}
                  readOnly={readOnly}
                  label={""}
                >
                  {ApprovalStatusSelectOptions()}
                </Select>
              </TableCell>
            </TableRow>
          </>
        )}
      <TableRow>
        <TableCell colSpan={2}>&nbsp;</TableCell>
      </TableRow>
      <TableRow>
        <TableCell colSpan={2}>
          <hr />
        </TableCell>
      </TableRow>
    </>
  );
};
